<template>
  <el-aside width="130px" class="side-menu">
    <el-scrollbar wrapClass="scrollbar-wrapper">
      <router-link :to="'/dashboard'" v-if="userId!='7'&&userId!='8'" class="hidden-xs">
        <!-- <i class="icon-logo-symbol logo"></i> -->
        <img class="logo" src="https://static.sanar.sa/images/static/logo.svg" alt="logo" />
      </router-link>
      <router-link :to="'/myprofile/view'" class="hidden-xs" v-else>
        <!-- <i class="icon-logo-symbol logo"></i> -->
        <img class="logo" src="https://static.sanar.sa/images/static/logo.svg" alt="logo" />
      </router-link>
      <router-link :to="'/dashboard'" content="Dashboard" v-if="userId!='7'&&userId!='8'">
        <el-tooltip class="item" effect="dark" content="Dashboard" placement="top-start"><i class="icon-dashboard item"></i></el-tooltip><span class="hidden-sm-and-up">Dashboard</span>
      </router-link>
      <router-link
        active-class="active"
        v-bind:to="item.path"
        v-if="functionid[item.fid]!==undefined"
        v-for="(item, i) in menuItem"
        v-bind:key="i"
      >
        <el-tooltip
          v-if="functionid[item.fid]!==undefined"
          class="item"
          effect="dark"
          :content="item.info"
          placement="top-start"
        >
          <i v-bind:class="item.icon"></i>
        </el-tooltip>
        <span class="hidden-sm-and-up">{{item.info}}</span>
      </router-link>
    </el-scrollbar>
  </el-aside>
</template>
<script>
export default {
  name: "SideBar",
  data() {
    return {
      functionData: null,
      menuItem: [
        /*  {
          icon: "icon-dashboard",
          path: "/dashboard",
          info: "Dashboard"
        }, */
        {
          icon: "icon-emplyee",
          path: "/employees",
          info: "Employee",
          fid: "111"
        },
        {
          icon: "icon-patients-status",
          path: "/patients",
          info: "Patient",
          fid: "112"
        },
        /*{
          "icon":"icon-first-aid", "path":"/doctors"
        },*/
        {
          icon: "icon-calendar3",
          path: "/appointments",
          info: "Appointment",
          fid: "113"
        },
        /* {
          icon: "icon-calendar",
          path: "/schedule",
          info: "Schedule Configuration",
          fid: "114"
        }, */
        /*{
          "icon":"icon-combined" ,"path":"/pharmacy"
        },
        {
          "icon":"icon-care",  "path":"/paramedical"
        },*/
        // {
        //   icon: "icon-padlock",
        //   path: "/accounts",
        //   info: "Accounts",
        //   fid: "119"
        // },
        {
          icon: "icon-manager",
          path: "/role-manager",
          info: "Role Management",
          fid: "115"
        },
        {
            icon: "icon-package",
            path: "/package",
            info: "Package",
            fid: "121"
          },
        {
          icon: "icon-king",
          path: "/master",
          info: "Master",
          fid: "116"
        },
        {
          icon: "icon-checklist",
          path: "/services",
          info: "Services",
          fid: "117"
        },
         /*{
            icon: "icon-review",
            path: "/reviews",
            info: "Reviews",
            fid: "115"
          }, */
          // {
          //   icon: "icon-coupon",
          //   path: "/coupon",
          //   info: "Coupon",
          //   fid: "120"
          // },
          {
          icon: "icon-settings",
          path: "/settings",
          info: "Settings",
          fid: "118"
        },
        {
          icon: "icon-star-review",
          path: "/rateandreview",
          info: "Rate And Review",
          fid: "117"
        }
      ],
      functionids: [],
      events: []
    };
  },
  props: {
    msg: String
  },
  created() {
    // this.functionids=this.$store.getters['employees/userData']
  },
  computed: {
    functionid() {
      this.functionData = JSON.parse(localStorage.getItem("fnids"));
      return this.functionData;
    },
    userId(){
      return JSON.parse(localStorage.getItem('utid'));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SideBar.vue